import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Group, GroupCollaboratorAlter, GroupIds, GroupRascunho, GroupUpdate } from 'src/app/models/group';
import { GroupDeleteModel } from 'src/app/models/group-delete-model';
import { ResponseBase } from 'src/app/models/response-base';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  private URL = environment.GATEWAY + 'group';
  // private URL = 'http://af8878d6354674085a29c95ff68310d6-1912565702.us-east-1.elb.amazonaws.com/api/Group';

  constructor(private http: HttpClient) { }

  getGroupsByCedente(cedenteGuid: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<Group[]>>(`${this.URL}/obter/${cedenteGuid}`, { headers });
  }

  getGroupsByBeneficio(cedenteGuid: string, produtoId: string[]) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.post<ResponseBase<Group[]>>(`${this.URL}/obter/${cedenteGuid}`, {productIDs: produtoId}, { headers });
  }

  getGroupById(cedenteGuid: string, groupGuid: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<Group>>(`${this.URL}/obter/${cedenteGuid}/${groupGuid}`, { headers });
  }

  addGroup(group: GroupUpdate) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.post<ResponseBase<GroupIds>>(`${this.URL}/create`, group, { headers });
  }

  updateGroup(group: GroupUpdate, groupGuid: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.put<ResponseBase<boolean>>(`${this.URL}/${groupGuid}`, group, { headers });
  }

  setRascunho(group: GroupRascunho) {
    sessionStorage.setItem(LocalStoreKeys.grupoRascunho, JSON.stringify(group));
  }

  getRascunho() {
    return JSON.parse(sessionStorage.getItem(LocalStoreKeys.grupoRascunho)) as GroupRascunho;
  }

  clearRascunho() {
    sessionStorage.removeItem(LocalStoreKeys.grupoRascunho);
  }

  setGrupo(grupo: Group) {
    sessionStorage.setItem(LocalStoreKeys.grupo, JSON.stringify(grupo));
  }

  getGrupo() {
    return JSON.parse(sessionStorage.getItem(LocalStoreKeys.grupo)) as Group;
  }

  deleteGroup(group: GroupDeleteModel, groupGuid: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.put<ResponseBase<boolean>>(`${this.URL}/delete/${groupGuid}`, group, { headers });
  }
}
